import { render, staticRenderFns } from "./PromoContent.vue?vue&type=template&id=47f9e634&scoped=true&"
import script from "./PromoContent.vue?vue&type=script&lang=js&"
export * from "./PromoContent.vue?vue&type=script&lang=js&"
import style0 from "./PromoContent.vue?vue&type=style&index=0&id=47f9e634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9e634",
  null
  
)

export default component.exports